module.exports = __webpack_public_path__ + "img/logo1_trial.19cf6446.png";